import type { RouteConfig } from "./types";

const equipmentRoutesConfig: RouteConfig[] = [
  {
    path: "/admin/equipment/casing",
    name: "Casings",
    componentName: "Casing",
    meta: {
      requiresAdmin: true,
      title: "Admin Casings"
    }
  },
  {
    path: "/admin/equipment/intake",
    name: "Intakes",
    componentName: "Intake",
    meta: {
      requiresAdmin: true,
      title: "Admin Intakes"
    }
  },
  {
    path: "/admin/equipment/hps-intake",
    name: "HPS Suction",
    componentName: "HpsIntake",
    meta: {
      requiresAdmin: true,
      title: "Admin HPS Suction"
    }
  },
  {
    path: "/admin/equipment/housings",
    name: "Housings",
    componentName: "Housing",
    meta: {
      requiresAdmin: true,
      title: "Admin Housings"
    }
  },
  {
    path: "/admin/equipment/mle",
    name: "MLE",
    componentName: "MLE",
    meta: {
      requiresAdmin: true,
      title: "Admin Motor Lead Extensions"
    }
  },
  {
    path: "/admin/equipment/motor",
    name: "Motors",
    componentName: "Motor",
    meta: {
      requiresAdmin: true,
      title: "Admin Motors"
    }
  },
  {
    path: "/admin/equipment/hps-motor",
    name: "HPS Motors",
    componentName: "HpsMotors",
    meta: {
      requiresAdmin: true,
      title: "Admin HPS Motors"
    }
  },
  {
    path: "/admin/equipment/bolt-on-discharge",
    name: "Bolt On Discharges",
    componentName: "BoltOnDischarge",
    meta: {
      requiresAdmin: true,
      title: "Admin Bolt On Discharges"
    }
  },
  {
    path: "/admin/equipment/hps-bolt-on-discharge",
    name: "HPS Bolt On Discharges",
    componentName: "HpsBoltOnDischarge",
    meta: {
      requiresAdmin: true,
      title: "Admin HPS Bolt On Discharges"
    }
  },
  {
    path: "/admin/equipment/cable",
    name: "Cables",
    componentName: "Cable",
    meta: {
      requiresAdmin: true,
      title: "Admin Cables"
    }
  },
  {
    path: "/admin/equipment/pump",
    name: "Pumps",
    componentName: "Pump",
    meta: {
      requiresAdmin: true,
      title: "Admin Pumps"
    }
  },
  {
    path: "/admin/equipment/seal",
    name: "Seals",
    componentName: "Seal",
    meta: {
      requiresAdmin: true,
      title: "Admin Seals"
    }
  },
  {
    path: "/admin/equipment/seal-motor-oil",
    name: "Seal Motor Oils",
    componentName: "SealMotorOil",
    meta: {
      requiresAdmin: true,
      title: "Admin Seal Motor Oils"
    }
  },
  {
    path: "/admin/equipment/sensor",
    name: "Sensors",
    componentName: "Sensor",
    meta: {
      requiresAdmin: true,
      title: "Admin Sensors"
    }
  },
  {
    path: "/admin/equipment/switchboard",
    name: "Switchboards",
    componentName: "Switchboard",
    meta: {
      requiresAdmin: true,
      title: "Admin Switchboards"
    }
  },
  {
    path: "/admin/equipment/step-down-transformer",
    name: "Step Down Transformers",
    componentName: "StepDownTransformer",
    meta: {
      requiresAdmin: true,
      title: "Admin Step Down Transformers"
    }
  },
  {
    path: "/admin/equipment/step-up-transformer",
    name: "Step Up Transformers",
    componentName: "StepUpTransformer",
    meta: {
      requiresAdmin: true,
      title: "Admin Step Up Transformers"
    }
  },
  {
    path: "/admin/equipment/tubing",
    name: "Tubings",
    componentName: "Tubing",
    meta: {
      requiresAdmin: true,
      title: "Admin Tubings"
    }
  },
  {
    path: "/admin/equipment/vsd",
    name: "VSD",
    componentName: "VSD",
    meta: {
      requiresAdmin: true,
      title: "Admin Variable Speed Drives"
    }
  },
  {
    path: "/admin/equipment/seal-thrust-chambers",
    name: "Seal Thrust Chambers",
    componentName: "SealThrustChambers",
    meta: {
      requiresAdmin: true,
      title: "Admin Seal Thrust Chambers"
    }
  },
  {
    path: "/admin/equipment/y-tool",
    name: "Y Block",
    componentName: "YTool",
    meta: {
      requiresAdmin: true,
      title: "Admin Y Blocks"
    }
  }
];
export default equipmentRoutesConfig;
